import { render, staticRenderFns } from "./ParamTipoVeiculo.vue?vue&type=template&id=9145d5e4"
import script from "./ParamTipoVeiculo.vue?vue&type=script&lang=js"
export * from "./ParamTipoVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports